import { useHistory } from 'react-router'

type RouteChangeEntry = {
  name: string
  startTime: number
  detail: {
    pathname: string
  }
}

const ROUTE_CHANGE = `route change`
export const useRouteChange = () => {
  try {
    const history = useHistory()
    history.listen((location) => {
      const { pathname } = location
      const routeChanges = performance.getEntriesByName(
        ROUTE_CHANGE
      ) as unknown as RouteChangeEntry[]

      if (
        routeChanges.length === 0 ||
        routeChanges[routeChanges.length - 1].detail.pathname !== pathname
      )
        performance.mark(ROUTE_CHANGE, {
          detail: {
            pathname,
          },
        })
    })
  } catch (e) {
    // Don’t let perf. analytics break the app
  }
}

export const getLatestRouteChange = (): PerformanceEntry | null => {
  const routeChanges = performance.getEntriesByName(ROUTE_CHANGE)

  return routeChanges.length > 0 ? routeChanges[routeChanges.length - 1] : null
}
